import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../../components/layout/Navbar/Navbar";
import Sidebar from "../../../components/layout/Sidebar/Sidebar";
import Header from "../../../components/layout/header/Header";
import VagaDetalhe from "../../../components/Vagas-Disponibilizadas/VagaDetalhe";
import VagasSolicitadasStatus from "../../../components/Vagas-Solicitadas/VagasSolicitadasStatus";
import { getCargoIdSidebar } from "../../../constants/sidebarConfig";
import apiService from "../../../services/api";
import vagasBlue from "../../../assets/vagasBlue.png";
import visibilityIcon from "../../../assets/visibility.png";
import {
  STATUS_FILTER_OPTIONS,
  SOLICITACAO_STATUS,
  applySolicitacaoFilters,
  formatPeriodo,
  formatTipoAtividade,
  getSolicitacaoStatusLabel,
  getStatusIcon,
} from "../../../utils/solicitacaoVagaFilters";

const NAVBAR_HEIGHT = 65;
const SIDEBAR_WIDTH = 300;

const GRID_COLUMNS = "56px 1fr 1fr 0.7fr 1fr 1.2fr 0.75fr 1fr 120px";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: rgb(255, 255, 255);
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  margin-top: 60px;
`;

const MainContent = styled.main`
  flex: 1;
  margin-left: ${SIDEBAR_WIDTH}px;
  overflow-y: auto;
  height: calc(100vh - ${NAVBAR_HEIGHT}px);
`;

const ListOuter = styled.div`
  display: flex;
  justify-content: center;
  background: #f9f9f9;
  font-family: public-sans, sans-serif;
`;

const ListContainer = styled.div`
  width: 100%;
`;

const ContentArea = styled.div`
  padding: 0 0 20px;
`;

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const UnitTableWrapper = styled.div`
  border-right: 1px solid #dfe3e8;
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 18px;
`;

const UnitTitle = styled.div`
  padding: 14px 32px;
  background: #f2f0f0;
  font-size: 16px;
  color: #6ab8a8;
  font-weight: 600;
`;

const UnitTitleValue = styled.span`
  color: #555555;
  padding-left: 8px;
`;

const UnitSeparator = styled.div`
  height: 1px;
  background: #dfe3e8;
`;

const StackedHeaderCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1.15;
  font-size: 14px;
  text-align: center;
`;

const HeaderRow = styled.div`
  display: grid;
  grid-template-columns: ${GRID_COLUMNS};
  align-items: center;
  height: 50px;
  background: #f2f0f0;
  font-size: 16px;
  font-weight: 700;
  color: #6ab8a8;

  > div {
    padding: 0 8px;
    border-right: 1px solid #d0d0d0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 100%;

    &:first-child {
      display: grid;
      place-items: center;
      padding: 0;
      justify-content: center;
    }

    &:last-child {
      border-right: none;
    }
  }
`;

const UnitRowsWrapper = styled.div``;

const ListRow = styled.div`
  display: grid;
  grid-template-columns: ${GRID_COLUMNS};
  align-items: center;
  height: 50px;
  font-size: 16px;
  color: #555555;
  font-weight: 500;
  border-top: 1px solid #e6e6e6;

  &:nth-child(odd) {
    background: #e8f5f3;
  }

  &:nth-child(even) {
    background: #ffffff;
  }

  > div {
    padding: 0 8px;
    border-right: 1px solid #d0d0d0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    text-align: center;

    &:first-child {
      display: grid;
      place-items: center;
      padding: 0;
    }

    &:last-child {
      border-right: none;
    }
  }
`;

const StatusCell = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;

const StatusIcon = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

const Actions = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
`;

const ActionButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;

  img {
    width: 22px;
    height: 22px;
  }
`;

const ActionLabel = styled.div`
  font-size: 14px;
  color: #ff9f1f;
`;

const EmptyMessage = styled.div`
  padding: 32px;
  text-align: center;
  color: #555;
  font-size: 15px;
`;

const StatusText = styled.span`
  font-weight: 600;
  color: ${(p) => p.$color};
`;

const SolicitacaoStatusCell = ({ status }) => {
  const cfg = SOLICITACAO_STATUS[status];
  if (cfg) return <StatusText $color={cfg.color}>{cfg.label}</StatusText>;
  const raw = status ? String(status).toUpperCase() : "-";
  return <StatusText $color="#555555">{raw}</StatusText>;
};

const handleVerSolicitacao = (solicitacao, navigate, setSelectedVaga) => {
  if (!solicitacao.vaga) return;

  if (solicitacao.status === "CONCEDIDO") {
    navigate("/ConfirmarConcessao", {
      state: { vagaId: solicitacao.vaga.id },
    });
    return;
  }

  if (solicitacao.status === "CONFIRMADA") {
    navigate("/ConfirmarConcessao", {
      state: { vagaId: solicitacao.vaga.id, onlyConfirmada: true },
    });
    return;
  }

  setSelectedVaga(solicitacao.vaga);
};

const VagasSolicitadas = () => {
  const [user, setUser] = useState(null);
  const [sidebarItems, setSidebarItems] = useState([]);
  const [solicitacoes, setSolicitacoes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [selectedVaga, setSelectedVaga] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const vagaIdFiltro = location.state?.vagaId ?? null;

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await apiService.getCurrentUser();
        setUser(userData);
        const filteredItems = getCargoIdSidebar(userData.cargoId);
        setSidebarItems(filteredItems);
      } catch (err) {
        console.error("Erro ao buscar usuário:", err);
      }
    };

    fetchUser();
  }, []);

  useEffect(() => {
    const fetchSolicitacoes = async () => {
      if (!user || (user.cargoId !== 2 && user.cargoId !== 3)) {
        setSolicitacoes([]);
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const response = await apiService.getSolicitacoesVaga();
        const data = response?.data ? response.data : response;
        setSolicitacoes(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err.message || "Falha ao carregar solicitações.");
      } finally {
        setLoading(false);
      }
    };

    fetchSolicitacoes();
  }, [user]);

  const filteredSolicitacoes = useMemo(
    () =>
      applySolicitacaoFilters(solicitacoes, {
        vagaId: vagaIdFiltro,
        status: statusFilter,
        searchTerm,
        sortOrder,
      }),
    [solicitacoes, searchTerm, vagaIdFiltro, statusFilter, sortOrder]
  );

  const groupedByEstabelecimento = useMemo(() => {
    return filteredSolicitacoes.reduce((acc, solicitacao) => {
      const estabelecimentoNome = solicitacao.vaga?.estabelecimentoSaude?.nome || "-";
      if (!acc[estabelecimentoNome]) acc[estabelecimentoNome] = [];
      acc[estabelecimentoNome].push(solicitacao);
      return acc;
    }, {});
  }, [filteredSolicitacoes]);

  const handleOrdenar = () => {
    setSortOrder((prev) => {
      if (prev === "asc") return "desc";
      if (prev === "desc") return null;
      return "asc";
    });
  };

  return (
    <PageWrapper>
      <Navbar
        onLogout={apiService.logout}
        showHome={true}
        showNotifications={true}
        showProfile={true}
        showLogout={true}
        user={user}
      />
      <ContentWrapper>
        <Sidebar items={sidebarItems} />
        <MainContent>
          <Header
            prefixText="VAGAS"
            icon={vagasBlue}
            title="Vagas Solicitadas"
            filtrar={true}
            ordenar={true}
            search={true}
            searchPlaceholder="Pesquisar vagas"
            searchValue={searchTerm}
            onSearchChange={setSearchTerm}
            onOrdenar={handleOrdenar}
            filterOptions={STATUS_FILTER_OPTIONS}
            onFilterChange={setStatusFilter}
          />
          {selectedVaga ? (
            <VagaDetalhe
              vaga={selectedVaga}
              user={user}
              onVoltar={() => setSelectedVaga(null)}
              onSolicitar={(vaga) => {
                setSelectedVaga(null);
                navigate("/solicitarVaga", { state: { vaga } });
              }}
              onVerSolicitacoes={(vaga) => {
                setSelectedVaga(null);
                navigate("/VagasSolicitadas", { state: { vagaId: vaga.id } });
              }}
            />
          ) : (
            <ListOuter>
              <ListContainer>
                <VagasSolicitadasStatus />
                <ContentArea>
                  {loading && <EmptyMessage>Carregando...</EmptyMessage>}
                  {error && <EmptyMessage>{error}</EmptyMessage>}

                  {!loading && !error && filteredSolicitacoes.length === 0 && (
                    <EmptyMessage>Nenhuma vaga solicitada.</EmptyMessage>
                  )}

                  {!loading && !error && filteredSolicitacoes.length > 0 && (
                    <ListWrapper>
                      {Object.keys(groupedByEstabelecimento).map((estabelecimentoNome) => (
                        <UnitTableWrapper key={estabelecimentoNome}>
                          <UnitTitle>
                            Unidade de saúde:
                            <UnitTitleValue>{estabelecimentoNome}</UnitTitleValue>
                          </UnitTitle>
                          <UnitSeparator />
                          <HeaderRow>
                              <StatusCell />
                              <div>ESPECIALDIADE</div>
                              <div>SETOR</div>
                              <div>TURNO</div>
                              <div>TIPO</div>
                              <div>PERÍODO</div>
                              <div>
                                <StackedHeaderCell>
                                  <span>VAGAS</span>
                                  <span>SOLICITADAS</span>
                                </StackedHeaderCell>
                              </div>
                              <div>STATUS</div>
                              <div>VER</div>
                            </HeaderRow>

                            <UnitRowsWrapper>
                              {groupedByEstabelecimento[estabelecimentoNome].map((solicitacao) => (
                                <ListRow key={solicitacao.id}>
                                  <StatusCell>
                                    <StatusIcon
                                      src={getStatusIcon(solicitacao.status)}
                                      alt={getSolicitacaoStatusLabel(solicitacao.status)}
                                    />
                                  </StatusCell>
                                  <div>{solicitacao.vaga?.unidadeAssistencial?.especialidade?.nome || "-"}</div>
                                  <div>{solicitacao.vaga?.unidadeAssistencial?.nome || "-"}</div>
                                  <div>{solicitacao.vaga?.turno || "-"}</div>
                                  <div>{formatTipoAtividade(solicitacao.vaga?.tipoAtividade)}</div>
                                  <div>{formatPeriodo(solicitacao.periodos)}</div>
                                  <div>{solicitacao.quantidadeAlunos ?? "-"}</div>
                                  <div>
                                    <SolicitacaoStatusCell status={solicitacao.status} />
                                  </div>
                                  <Actions>
                                    <ActionButton
                                      onClick={() =>
                                        handleVerSolicitacao(solicitacao, navigate, setSelectedVaga)
                                      }
                                      title="Ver detalhes da vaga"
                                      role="button"
                                      tabIndex={0}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                          e.preventDefault();
                                          handleVerSolicitacao(solicitacao, navigate, setSelectedVaga);
                                        }
                                      }}
                                    >
                                      <img src={visibilityIcon} alt="Ver" />
                                      <ActionLabel>Ver</ActionLabel>
                                    </ActionButton>
                                  </Actions>
                                </ListRow>
                              ))}
                            </UnitRowsWrapper>
                        </UnitTableWrapper>
                      ))}
                    </ListWrapper>
                  )}
                </ContentArea>
              </ListContainer>
            </ListOuter>
          )}
        </MainContent>
      </ContentWrapper>
    </PageWrapper>
  );
};

export default VagasSolicitadas;
